// GeoServer layer URL templates carry a `{format}` placeholder, sometimes percent-encoded.
export function applyFormat(template: string, format: string): string {
	return template.replaceAll('{format}', format).replaceAll('%7Bformat%7D', format);
}
